"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateResponsiveState = void 0;
var utils_1 = require("../utils");
var constants_1 = require("./constants");
var calculateResponsiveState = function (payload) {
    return utils_1.makeAction(constants_1.CALCULATE_RESPONSIVE_STATE, payload);
};
exports.calculateResponsiveState = calculateResponsiveState;
//# sourceMappingURL=actions.js.map